
/**
 * 前端多语言解决方案
 */
import _ from 'underscore';
import url from 'c-url';
import LangPack from './pack'; // 默认的配置包

let lang = url.query('language') ? url.query('language') : 'en-US';
let langType = lang.replace('-', '').toLowerCase();
let langPack = LangPack[langType] || LangPack['enus'];
let appName = url.query('appname') || 'Uplive'
document.title = appName.replace(/Up直播|Uplive/g, appName);

module.exports = {
    init: function () {
        $('html').attr('lang', lang);
        $('body').addClass(langType);
        if (appName != 'Uplive') {
            $('body').addClass('lovelive');
        }
    },
    getLangType: function () {
        return langType;
    },
    template: function (tplStr, data) {
        let tpl = langPack[tplStr];

        if (tpl) {
            // for 活动规则。段落分隔符号：@@@@
            if (tpl.indexOf('@@@@') > 0) {
                let strArr = [];

                strArr.push('<ul>');
                tpl.split('@@@@').forEach(function (item, index) {
                    item && strArr.push('<li>' + item + '</li>');
                });
                strArr.push('</ul>');
                tpl = strArr.join('');
            }
        } else {
            // 没有找到，直接返回模版string
            tpl = tplStr;
        }

        let compiled = _.template(tpl);
        return compiled(data).replace(/Up直播|Uplive/g, appName);
    }
}



// WEBPACK FOOTER //
// ./js/lang/index.js